import { RETAILER_CONFIG_MAP, RetailerKey } from './retailer-config';

export function getEnabledRetailerKeys(flags: { walmart: boolean }): RetailerKey[] {
  const keys: RetailerKey[] = [RetailerKey.AmazonUS];
  if (flags.walmart) keys.push(RetailerKey.WalmartUS);
  return keys;
}

export function detectRetailerFromInput(value: string, enabledKeys: RetailerKey[]): RetailerKey | null {
  if (!value) return null;
  const entries = enabledKeys.map((k) => RETAILER_CONFIG_MAP[k]);
  const fullMatches = entries.filter((c) => c.itemIdPattern.test(value));
  if (fullMatches.length === 1) return fullMatches[0].key;
  if (fullMatches.length > 1) return null;

  const partialMatches = entries.filter((c) => c.detectionPattern.test(value));
  return partialMatches.length === 1 ? partialMatches[0].key : null;
}
